import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../components/Modal";
import { aspetto_logo } from "../../constant/_constant";
import { useState } from "react";

const ErrorModal = ({
  isOpen = true,
  errorMessage = "",
  redirectPath = "/",
}) => {
  const [open, setOpen] = useState(isOpen);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(redirectPath);
  };

  return (
    <Modal isOpen={open}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <img src={aspetto_logo} height={80} alt="aspetto_logo" />
        </div>
        <h2 className="h3 text-center mb-3">Verification Failed</h2>

        <p className="text-center text-danger">{errorMessage}</p>
        <p className="text-center">
          Don’t worry — it looks like this link can’t be used right now. This
          may happen if the link is invalid, expired, or has already been used.
          For security reasons, we recommend contacting the administrator to
          request a new one. Your information remains safe, and it only takes a
          moment to get back on track.
        </p>
      </ModalContent>
    </Modal>
  );
};

export default ErrorModal;
